export default __webpack_public_path__ + "809d02cb88d5cbf7584fc40b2bebef10.svg";